import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionSheet, ActionSheetHeader, renderActionSheetItems } from "@air/primitive-action-sheet";
export const MobileFiltersSubMenu = (param)=>{
    let { onClose, options } = param;
    return /*#__PURE__*/ _jsxs(ActionSheet, {
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx(ActionSheetHeader, {
                children: "Select custom field"
            }),
            renderActionSheetItems({
                options: options.map((option)=>{
                    if (option.type !== "item") return option;
                    return {
                        ...option,
                        onSelect: ()=>{
                            var _option_onSelect;
                            onClose();
                            (_option_onSelect = option.onSelect) === null || _option_onSelect === void 0 ? void 0 : _option_onSelect.call(option);
                        },
                        type: "item"
                    };
                })
            })
        ]
    });
};
